// extracted by mini-css-extract-plugin
export default {"profile":"MainProfile_profile__aVYRw","title":"MainProfile_title__VB48L","descr":"MainProfile_descr__U73ba"};